import { FC } from 'react';
import { useWindowSize } from '../../custom-hooks/useWindowSize';

interface Props {
  isBlocked?: boolean;
}
const AssessmentCompletedStroke: FC<Props> = ({ isBlocked }) => {
  const { width } = useWindowSize();
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="33"
        height="31"
        viewBox="0 0 33 31"
        fill="none"
        style={{
          position: 'relative',
          top: `${width >= 640 ? (isBlocked ? '-227px' : '-154px') : isBlocked ? '-219px' : '-146px'}`,
          left: `${width >= 640 ? '261px' : '208px'}`,
        }}
      >
        <path
          d="M28.832 2C30.4257 2.00002 31.521 3.88049 30.6025 5.34473C28.3668 8.9087 25.6248 13.5348 23.4355 18.0332C22.341 20.2822 21.3691 22.5314 20.667 24.6211C20.2198 25.9521 19.8652 27.2715 19.6689 28.5186C19.6384 28.5185 19.6078 28.5187 19.5771 28.5186C19.7643 16.9583 15.3749 10.2592 10.543 6.48633C8.0348 4.52793 5.48366 3.41628 3.5625 2.79297C2.98151 2.60447 2.45435 2.46227 2 2.35156L2 2L28.832 2Z"
          fill="#FEFBF9"
          stroke="#F1F0EE"
          strokeWidth="4"
        />
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="23"
        viewBox="0 0 30 23"
        fill="none"
        style={{
          position: 'relative',
          top: `${width >= 640 ? (isBlocked ? '-232px' : '-158px') : isBlocked ? '-232px' : '-150px'}`,
          left: `${width >= 640 ? '226px' : '173px'}`,
        }}
      >
        <path d="M-2.18558e-08 22.5L-1.00536e-06 0L30 -1.31134e-06L18 23L-2.18558e-08 22.5Z" fill="#FEFBF9" />
      </svg>
    </>
  );
};

export default AssessmentCompletedStroke;
